<template>
  <div class="homeContainer">
    <div class="contant">
      <div class="top">
        <div class="form">
          <el-date-picker
            v-model="form.formTime"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
            style="width:240px;height:30px;float:left;margin:22px 20px;"
          ></el-date-picker>

          <div class="form-item">
            <el-input v-model="form.searchValue" placeholder="订单号/资源ID/创建人ID" style="width:200px;"></el-input>
            <i class="el-icon-search" @click="search"></i>
          </div>
        </div>
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :header-cell-style="tableClass"
          :default-sort="{slot: 'date', order: 'descending'}"
        >
          <el-table-column type="selection" width="50px;"></el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="200px;"></el-table-column>
          <el-table-column prop="channelItemName" label="产品名称"></el-table-column>
          <el-table-column label="子产品名称">
            <template slot-scope="scope">{{scope.row.channelItemAppendName||'--'}}</template>
          </el-table-column>
          <!-- <el-table-column label="类型" :filters="typeFilters" :filter-method="filterType">
            <template>
              <el-link type="success" :underline="false" style="cursor:text;">新购</el-link>
            </template>
          </el-table-column> -->
          <el-table-column label="订单创建时间" align="center" prop="created_at" sortable width="200px;"></el-table-column>
          <el-table-column
            label="状态"
            :filters="filters"
            :filter-method="filterStatus"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                :type="orderStatus(scope.row.orderStatus)"
                :underline="false"
                style="cursor:text;"
              >{{scope.row.orderStatusName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="订单金额(元)" align="center">
            <template slot-scope="scope">
              {{scope.row.totalSum}}
              <i
                class="el-icon-warning-outline"
                style="color:#FF9D00;font-size:13px;"
                v-show="scope.row.totalSum=='00.00'"
              ></i>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="$router.push(`/brandReview/cashier?payNo=${scope.row.orderNo}&payMoney=${scope.row.payTotalSum}&serveItem=${scope.row.channelItemName}`)"
                v-show="scope.row.orderStatus!==2"
              >付款</el-button>
              <el-button
                type="text"
                size="small"
                @click="deleteOrder(scope.row.orderNo)"
                v-show="scope.row.orderStatus!==2"
              >取消</el-button>
              <el-button type="text" size="small" @click="goDetail(scope.row.orderNo)">详情</el-button>
              <el-button
                type="text"
                size="small"
                @click="deleteOrder(scope.row.orderNo)"
                v-show="scope.row.orderStatus==32"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <b>共{{total}}条</b>
          <div>
            <span class="demonstration">调整每页显示条数</span>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 30, 40,50]"
              :page-size="10"
              layout="sizes, prev, pager, next"
              :total="total"
              style="display:inline-block;"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList, delOrder } from "@/api/fill.js";
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
      //过滤选项
      filters: [
        { text: "待付款", value: "待付款" },
        { text: "已付款", value: "已付款" },
        { text: "服务中", value: "服务中" },
        { text: "已完成", value: "已完成" },
        { text: "已退款", value: "已退款" },
        { text: "已作废", value: "已作废" },
      ],
      typeFilters: [{ text: "新购", value: "新购" }],
      //数据总数
      total: 0,
      // 表单数据
      form: {
        // 表单中时间数据
        formTime: "",
        // 表单中关键字查询数据
        searchValue: "",
        // 表单中开始时间
        startTime: "",
        // 表单中结束时间
        endTime: "",
      },
      //表格总数据
      tableData: [],
      // 渲染数据
      tableList: [],
      formInline: {
        user: "",
        region: "",
      },
      multipleSelection: [],
      //当前页
      currentPage: 1,
      // 每页展示条数
      pageSize: 10,
    };
  },
  computed: {
    tableClass() {
      return { background: "rgba(247,252,255,1)", border: "none" };
    },
    // 根据订单状态给不同的样式
    // 1: 待付款, 2: 已付款, 4: 服务中, 8: 已完成, 16: 已退款, 32: 已作废
    orderStatus() {
      let type = "";
      return function (status) {
        switch (status) {
          case 1:
            return (type = "warning");
            break;
          case 2:
            return (type = "success");
            break;
          case 4:
            return (type = "primary");
            break;
          case 8:
            return (type = "success");
            break;
          case 16:
            return (type = "default");
            break;
          case 32:
            return (type = "default");
            break;
          default:
            return (type = "default");
            break;
        }
      };
    },
  },
  methods: {
    // 跳转到订单详情
    goDetail(orderNo) {
      this.$router.push(
        `/brandReview/brandController/orderDetail?orderNo=${orderNo}`
      );
      // console.log(orderNo);
    },
    // 删除订单
    deleteOrder(orderNo) {
      let params = {
        orderNo,
      };
      this.loading = true
      delOrder(params).then((res) => {
        if (res.status == 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getOrderListInfo();
        } else {
          this.$message.error("数据请求失败");
        }
      });
    },
    // 查询
    search() {
      // 校验输入信息是否全为空
      let emptyNum = 0;
      for (let key in this.form) {
        if (this.form[key] == "") {
          emptyNum++;
        }
      }
      // 如果全为空，则不请求
      if (emptyNum == 4) {
        this.$message.error("请输入有效信息！");
      } else {
        this.currentPage = 1;
        this.getOrderListInfo(
          "",
          "",
          this.form.searchValue,
          "",
          this.form.startTime,
          this.form.endTime
        );
      }
    },
    // 获取订单列表信息
    getOrderListInfo(
      pageIndex, //当前页
      channelItemName, // N 产品名称
      channelServiceNo, // N 渠道订单号
      orderStatus, // N 订单状态
      startTime, // N 开始时间
      entTime // N 结束时间
    ) {
      let params = {
        pageIndex: pageIndex || 1, // Y 当前页
        pageSize: this.pageSize || 10, // Y 每页大小，最大为50
        channelItemName, // N 产品名称
        channelServiceNo, // N 渠道订单号
        orderStatus, // N 订单状态
        startTime, // N 开始时间
        entTime, // N 结束时间
      };
      this.loading = true
      getOrderList(params).then((res) => {
        if (res.status === 0) {
          this.loading = false;
          this.tableData = res.data.map((item, index) => {
            item.created_at = moment(item.created_at).format("YYYY-MM-DD HH:mm:ss");
            return item;
          });
          this.total = res.dataCount;
        } else {
          this.$message.error("数据请求失败");
        }
      });
    },
    // 监听每页展示条数变化
    handleSizeChange(pageSize) {
      // console.log("每页展示条数变了", pageSize);
      this.pageSize = pageSize;
      this.getOrderListInfo(
        "", //当前页(默认为1)
        "", //产品名称
        this.form.searchValue, //渠道订单号
        "", //订单状态
        this.form.startTime, //开始时间
        this.form.endTime //结束时间
      );
    },
    // 监听当前页变化
    handleCurrentChange(currentPage) {
      // console.log("当前页变了", this.currentPage);
      this.getOrderListInfo(
        this.currentPage, //当前页
        "", //产品名称
        this.form.searchValue, //渠道订单号
        "", //订单状态
        this.form.startTime, //开始时间
        this.form.endTime //结束时间
      );
    },
    // 类型过滤触发函数
    filterType(value, row, column) {
      return row["channelItemName"] === value;
    },
    // 状态过滤触发函数
    filterStatus(value, row, column) {
      return row["orderStatusName"] === value;
    },
    // 监听表单中的时间数据变化
    changeDate() {
      console.log(this.form.formTime)
      let startTime = new Date(this.form.formTime[0]);
      let endTime = new Date(this.form.formTime[1]);
      let startYear = startTime.getFullYear();
      let startMonth = (startTime.getMonth() + 1).toString().padStart(2,0);
      let startDay = startTime.getDate().toString().padStart(2,0);
      let endYear = endTime.getFullYear();
      let endMonth = (endTime.getMonth() + 1).toString().padStart(2,0);
      let endDay = endTime.getDate().toString().padStart(2,0);
      this.form.startTime = startYear + "-" + startMonth + "-" + startDay;
      this.form.endTime = endYear + "-" + endMonth + "-" + endDay;
    },
    // 切换表格每一行选中状态
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 监听每一行的选中状态
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    // console.log("mounted周期执行了", this.$router);
    this.getOrderListInfo();
  },
  beforeRouteEnter(to, from, next) {
    // 路由导航钩子，此时还不能获取组件实例 `this`，所以无法在data中定义变量（利用vm除外）
    // 所以，利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
    if (from.name == "orderDetail") {
      to.meta.isBack = true;
      //判断是从哪个路由过来的，
      //如果是orderDetail过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // console.log("数据更新了");
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false;
  },
};
</script>

<style lang = 'scss' scoped>
.homeContainer {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .contant {
    padding: 20px;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    .top {
      width: 98%;
      box-sizing: border-box;
      overflow: hidden;
      position: absolute;
      top: 20px;
      bottom: 13px;
      left: 50%;
      transform: translateX(-50%);
      .block {
        margin: 0;
        height: 67px;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        bottom: 3px;
        padding-left: 14px;
        background: rgba(255, 255, 255, 1);
        border-top: 1px solid rgba(229, 229, 229, 1);
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
        div {
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 17px;
            display: inline-block;
          }
        }
      }
      .form {
        width: 100%;
        height: 70px;
        position: absolute;
        top: 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
        line-height: 70px;
        /deep/.el-range-editor {
          .el-range__icon {
            font-size: 14px;
            margin-left: -5px;
            color: #c0c4cc;
            float: left;
            line-height: 24px;
          }
          .el-range__close-icon {
            font-size: 14px;
            color: #c0c4cc;
            width: 25px;
            float: right;
            line-height: 24px;
          }
          .el-range-separator {
            display: inline-block;
            height: 100%;
            padding: 0 5px;
            margin: 0;
            text-align: center;
            line-height: 21px;
            font-size: 14px;
            width: 17%;
            color: #303133;
          }
        }
        .form-item {
          width: 200px;
          height: 30px;
          float: left;
          .el-input {
            width: 100%;
            float: left;
          }
          .el-icon-search {
            position: absolute;
            cursor: pointer;
            font-weight: 600;
            top: 30px;
            left: 458px;
          }
        }
        /deep/.el-input__inner {
          border-radius: 0px;
          width: 100%;
          height: 30px;
          padding-left: 10px;
        }
        /deep/.el-input__icon {
          &.el-icon-time {
            display: none;
          }
        }
        /deep/.el-input__suffix {
          .el-select__caret {
            line-height: 30px;
          }
          .el-input__suffix-inner {
            .el-icon-circle-close {
              height: 30px;
              line-height: 30px;
            }
          }
        }
        .el-input {
          height: 30px;
          width: 60%;
        }
        input {
          width: 60%;
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(187, 187, 187, 1);
          line-height: 17px;
          text-indent: 10px;
        }
      }
      .title {
        font-size: 10px;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 14px;
      }
      .itemWrap {
        display: flex;
        justify-content: space-around;
        .item {
          display: flex;
          flex-direction: column;
          text-align: center;
          span {
            font-size: 26px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
          }
          b {
            font-size: 9px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 12px;
          }
        }
        .line {
          width: 1px;
          height: 51px;
          background: #dddddd;
        }
      }
      .el-form {
        .el-button {
          width: 63px;
          height: 21px;
          line-height: 21px;
          text-align: center;
          font-size: 9px;
          padding: 0;
          margin-top: 14px;
          border-radius: 0;
        }
      }
    }
  }
  /deep/.el-table {
    position: absolute;
    top: 100px;
    bottom: 70px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    overflow: auto;
    td {
      padding: 7.5px 0;
    }
    .el-table__header-wrapper {
      position: sticky;
      width: 100%;
      top: 0;
      z-index: 3;
      .el-table__header {
        .has-gutter {
          tr {
            th {
              padding: 8.5px 0;
            }
            th:nth-of-type(1) {
              .cell {
                padding-left: 14px;
              }
            }
          }
        }
      }
    }
  }
  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }
}
</style>